import gql from 'graphql-tag';

export const conversationUserPromptFragment = gql`
  fragment conversationUserPromptFragment on ConversationUserPrompt {
    dokkioClass
    id
    prompt
    receivedAt
    userRating
    userRatingReason
  }
`;
export default conversationUserPromptFragment;
